




























import Vue, { PropType } from 'vue';
import SanityBlockContent from '@/components/SanityBlockContent.vue';
import EmployeePortrait from '@/components/EmployeePortrait.vue';
import Employee from '@/models/employee';

export default Vue.extend({
  name: 'TextWithPeoplePanel',
  components: {
    SanityBlockContent,
    EmployeePortrait,
  },
  props: {
    headline: {
      type: String,
      default: () => 'Media',
    },
    text: {
      type: Array,
      required: true,
    },
    people: {
      type: Array as PropType<Array<Employee>>,
      required: false,
      default: () => [],
    },
    headlineSize: String,
    headlinePosition: String,
  },
});
